import { createBrowserHistory } from "history";

export const history = createBrowserHistory({
    basename: "/", // The base URL of the app (see below)
    forceRefresh: false // Set true to force full page refreshes
});
